module.exports = __webpack_public_path__ + "static/google-play-badge-162b962eb4a869995feb0f6dcab4b46a.png";